import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from '../../../environments/environment';

export class SentryErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (environment.SENTRY.length > 0) {
      if (!(error instanceof HttpErrorResponse)) {
        Sentry.captureException(error);
      }
    }
  }
}
